<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Proyectos</li>
        <li class="breadcrumb-item active" aria-current="page">Proyectos en Fondeo</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 mb-4">
          <vx-card>
            <div class="row">
              <div class="col-md-9">
                <h1 class="bold big-title m-0">Proyectos en <span>fondeo</span>.</h1>
              </div>
              <div class="col-md-3">
                <vs-button @click="downloadXlsx()" color="success" type="filled" icon="download">Descargar reporte
                  (.xlsx)
                </vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="result-zone row" style="margin-top:20px;">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <table class="table table-hover">
                <thead>
                <th class="header" style="text-align: left !important">PID</th>
                <th class="header" style="text-align: left !important">Alias</th>
                <th class="header">Días en Fondeo</th>
                <th class="header">Valor Proyecto</th>
                <th class="header">% Avance</th>
                <th class="header">$ Avance</th>
                <th class="header">$ Faltante</th>
                <th class="header">Faltante Lineal</th>
                <th class="header">Faltante al 25%</th>
                <th class="header">Faltante al 75%</th>
                <th class="header">Faltante Diario</th>
                </thead>
                <tbody>
                <tr style="border-bottom: solid 2px">
                  <td></td>
                  <td style="font-weight: bold !important;">Total</td>
                  <td align="right" style="font-weight: bold !important;"></td>
                  <td align="right" style="font-weight: bold !important;">{{ format_price(totalValor, 2) }}</td>
                  <td align="right" style="font-weight: bold !important;">{{ format_price(promPorAvance * 100, 2) }}%
                  </td>
                  <td align="right" style="font-weight: bold !important;">${{ format_price(totalMoneyAvance, 2) }}</td>
                  <td align="right" style="font-weight: bold !important;">${{ format_price(totalMoneyFaltante, 2) }}
                  </td>
                  <td align="right" style="font-weight: bold !important;">${{ format_price(totalFaltanteLineal, 2) }}
                  </td>
                  <td align="right" style="font-weight: bold !important;">${{ format_price(totalFaltante25, 2) }}</td>
                  <td align="right" style="font-weight: bold !important;">${{ format_price(totalFaltante75, 2) }}</td>
                  <td align="right" style="font-weight: bold !important;">${{ format_price(totalFaltanteDiario, 2) }}
                  </td>
                </tr>
                <tr v-for="renglon in data">
                  <td style="font-weight: bold !important;"><a
                    :href="$sanitizeUrl('/project/' + renglon.idp)" target="_blank">{{ renglon.idp }}</a></td>
                  <td>{{ renglon.alias }}</td>
                  <td align="right">{{ format_price(renglon.dias) }}</td>
                  <td align="right">{{ format_price(renglon.valor, 2) }}</td>
                  <td align="right">{{ format_price(renglon.porAvance * 100, 2) }}%</td>
                  <td align="right">${{ format_price(renglon.moneyAvance, 2) }}</td>
                  <td align="right">${{ format_price(renglon.moneyFaltante, 2) }}</td>
                  <td align="right">${{ format_price(renglon.faltanteLineal, 2) }}</td>
                  <td align="right">${{ format_price(renglon.faltante25, 2) }}</td>
                  <td align="right">${{ format_price(renglon.faltante75, 2) }}</td>
                  <td align="right">${{ format_price(renglon.faltanteDiario, 2) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import {Currency} from "@/models/Security/Currency";

export default {
  props: [],
  mounted() {
    axios.get('/api/funding').then((resolve) => {
      this.data = resolve.data.data;
      this.promDias = resolve.data.promDias;
      this.totalValor = resolve.data.totalValor;
      this.promPorAvance = resolve.data.promPorAvance;
      this.totalMoneyAvance = resolve.data.totalMoneyAvance;
      this.totalMoneyFaltante = resolve.data.totalMoneyFaltante;
      this.totalFaltanteLineal = resolve.data.totalFaltanteLineal;
      this.totalFaltante25 = resolve.data.totalFaltante25;
      this.totalFaltante75 = resolve.data.totalFaltante75;
      this.totalFaltanteDiario = resolve.data.totalFaltanteDiario;
    });

  },
  data() {
    return {
      data: [],
      promDias: 0,
      totalValor: 0,
      promPorAvance: 0,
      totalMoneyAvance: 0,
      totalMoneyFaltante: 0,
      totalFaltanteLineal: 0,
      totalFaltante25: 0,
      totalFaltante75: 0,
      totalFaltanteDiario: 0,
    }
  },
  methods: {
    format_price(value, decimales = 0) {
      let val = (value / 1).toFixed(decimales).replace(',', '.')
      return Currency.format(parseFloat(val))
    },
    downloadXlsx() {
      try {
        let url = `${process.env.VUE_APP_API_DOMAIN}/api/v2/projects/getFundingProjects?access_token=${this.user.access_token}`;
        window.open(url, '_blank');
      } catch (error) {
        console.log(error);
      }
    }
  },
}
</script>
